import { render, staticRenderFns } from "./industryPolicy.vue?vue&type=template&id=4e1916c2&scoped=true"
import script from "./industryPolicy.vue?vue&type=script&lang=js"
export * from "./industryPolicy.vue?vue&type=script&lang=js"
import style0 from "./industryPolicy.vue?vue&type=style&index=0&id=4e1916c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1916c2",
  null
  
)

export default component.exports